import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CreateUserIcon } from './styles'
import { Tooltip } from 'shards-react'

const CreateIcon = ({ disabled, className, id, label }) => {
    const [open, setOpen] = useState(false)

    const toggle = () => {
        setOpen(!open)
    }
    return (
        <>
            <CreateUserIcon disabled={disabled} className={`material-icons ${className}`} id={id}>
                add_circle
            </CreateUserIcon>
            <Tooltip open={open} target={`#${id}`} toggle={toggle}>
                {disabled ? 'Você não tem permissão para executar esta ação.' : label}
            </Tooltip>
        </>
    )
}

CreateIcon.propTypes = {
    label: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
}

export default CreateIcon
